/** Helpers for files received via Web Share Target. */

const CACHE = "share-target-v1";
const PREFIX = "/__shared__/";

export async function takeSharedFiles(): Promise<File[]> {
  if (!("caches" in window)) return [];
  const cache = await caches.open(CACHE);
  const keys = await cache.keys();
  const sharedKeys = keys
    .map((r) => r.url)
    .filter((u) => u.includes(PREFIX))
    .sort();
  const files: File[] = [];
  for (const key of sharedKeys) {
    const res = await cache.match(key);
    if (!res) continue;
    const blob = await res.blob();
    const rawName = res.headers.get("x-filename");
    const name = rawName ? decodeURIComponent(rawName) : "receipt.jpg";
    const type =
      res.headers.get("content-type") || blob.type || "application/octet-stream";
    files.push(new File([blob], name, { type }));
    await cache.delete(key);
  }
  return files;
}
